module.exports = __webpack_public_path__ + "static/media/Engpic2.8898e645.png";